import { useState } from 'react';
import { toast } from '@/components/ui/toaster.jsx';
import { placeModel } from '@/services/aircraft-identity.service.js';

const btn = 'inline-flex items-center rounded-[5px] border border-accent bg-accent px-2.5 py-1 text-[12px] text-white hover:brightness-110 disabled:opacity-50';
const errText = (e) => e?.body?.error || e?.message || 'failed';

// "Place this model" (MAKE-MODEL-TIME-SPEC section 3): pick a family David already named, or name a new one. Nothing
// defaults: the button stays off until one of the two is chosen. The family's name words the pilot form's question.
export default function PlaceModel({ model, families, onPlaced }) {
  const [familyId, setFamilyId] = useState('');
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);
  const isNew = familyId === '__new__';
  const ready = isNew ? name.trim().length > 0 : !!familyId;
  const target = isNew ? `a new family "${name.trim()}"` : `"${(families.find((f) => f.id === familyId) || {}).display_name || ''}"`;
  const save = async () => {
    setSaving(true);
    try {
      const out = await placeModel(isNew ? { model_key: model.model_key, new_family_name: name.trim() } : { model_key: model.model_key, family_id: familyId });
      toast.success(`${out.label} is in "${out.family.display_name}"`);
      onPlaced?.(out);
    } catch (e) { toast.error(`Not placed: ${errText(e)}`); } finally { setSaving(false); }
  };
  return (
    <div className="flex flex-wrap items-center gap-2">
      <select value={familyId} onChange={(e) => setFamilyId(e.target.value)} className="rounded-[5px] border border-border bg-surface px-2 py-1 text-[13px] text-text">
        <option value="">Pick a family</option>
        {families.map((f) => <option key={f.id} value={f.id}>{f.display_name}</option>)}
        <option value="__new__">Name a new family</option>
      </select>
      {isNew ? <input value={name} onChange={(e) => setName(e.target.value)} placeholder='e.g. "all Cessna 172 models"' className="w-56 rounded-[5px] border border-border bg-surface px-2 py-1 text-[13px] text-text" /> : null}
      <button type="button" className={btn} disabled={!ready || saving} onClick={save}>
        {saving ? 'Placing' : ready ? `Place ${model.label} in ${target}` : 'Place this model'}
      </button>
    </div>
  );
}
